import debug from 'debug';
import BaseComponent from 'Global/Shared/Components/BaseComponent/BaseComponent';
import Sitecore from 'Global/Shared/Components/Sitecore/Sitecore';
import SitecoreItems from './render/sitecore-items';
import ApiItems from './render/api-items';

const log = debug('BoostBanner');

class BoostBanner extends BaseComponent {
	constructor(element) {
		super(element);

		this.initialize();
	}

	/**
	 * @returns {Object} settings
	 */
	 getSettings() {
		let settings = {};

		try {
			settings = JSON.parse(this.element.getAttribute('data-settings'));
			log('getSettings()', settings);
			this.settings = settings;
		} catch (error) {
			log('getSettings() - error', error);
			settings = null;
		}

		return settings;
	}

	initialize() {
		if (this.getSettings() === null) return;

		this.initDomCache();

		if (this.settings.location !== '') {
			const apiItems = new ApiItems(this.element, this.dom, this.settings);
		} else {
			if (Sitecore.isEdit()) return;
			const sitecoreItems = new SitecoreItems(this.element, this.dom, this.settings);
		}
	}
}

export default BoostBanner;
